/**
 * abilities.ts — Typed ability data with class-specific lookups.
 */

import type { AbilitiesData, ClassAbilities, AbilityDefinition, ClassId } from './types';
import abilityData from './abilities.json';

/** The complete abilities data structure. */
export const abilitiesData: AbilitiesData = abilityData as unknown as AbilitiesData;

/** Get abilities for a specific class. */
export function getClassAbilities(classId: ClassId): ClassAbilities | undefined {
  return abilitiesData.classes[classId];
}

/** Get a specific ability by class and ability ID. */
export function getAbility(
  classId: ClassId,
  abilityId: string
): AbilityDefinition | undefined {
  const classData = abilitiesData.classes[classId];
  if (!classData) return undefined;
  return classData.abilities.find((a) => a.id === abilityId);
}

/** Get the evolution milestones. */
export const evolutionMilestones = abilitiesData.evolutionMilestones;
